import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Empresa } from '../models/empresa';

@Injectable({
  providedIn: 'root',
})
export class EmpresaService {

  private url = `${environment.apiUrl}/empresas`;

  constructor(private http: HttpClient) {}

  listar(): Observable<Empresa[]> {
    return this.http.get<Empresa[]>(this.url);
  }

  obterPorId(id: string): Observable<Empresa> {
    return this.http.get<Empresa>(`${this.url}/${id}`);
  }

  obterPorCpfCnpj(cpfCnpj: string): Observable<Empresa> {
    const normalized = (cpfCnpj || '').replace(/\D/g, '');
    return this.http.get<Empresa>(`${this.url}/por-cpfcnpj/${normalized}`);
  }

  // Se o tenantId é o ID da empresa, este endpoint é redundante com obterPorId,
  // mas vamos mantê-lo se a intenção for explícita.
  obterPorTenant(tenantId: string): Observable<Empresa> {
    return this.http.get<Empresa>(`${this.url}/${tenantId}`);
  }

  create(empresa: Empresa): Observable<Empresa> {
    return this.http.post<Empresa>(this.url, empresa);
  }

  update(id: string, empresa: Empresa): Observable<Empresa> {
    return this.http.put<Empresa>(`${this.url}/${id}`, empresa);
  }

  ativarDesativar(id: string, ativo: boolean): Observable<Empresa> {
    return this.http.patch<Empresa>(`${this.url}/${id}/ativo`, { ativo });
  }

  // Alias para manter compatibilidade se necessário
  cadastrar(empresa: Empresa): Observable<Empresa> {
    return this.create(empresa);
  }

  atualizar(id: string, empresa: Empresa): Observable<Empresa> {
    return this.update(id, empresa);
  }
}
